import { render, staticRenderFns } from "./PrimaryIssue.vue?vue&type=template&id=dca0790e&"
import script from "./PrimaryIssue.vue?vue&type=script&lang=ts&"
export * from "./PrimaryIssue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dca0790e')) {
      api.createRecord('dca0790e', component.options)
    } else {
      api.reload('dca0790e', component.options)
    }
    module.hot.accept("./PrimaryIssue.vue?vue&type=template&id=dca0790e&", function () {
      api.rerender('dca0790e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/ward/PrimaryIssue.vue"
export default component.exports